export default __webpack_public_path__ + "static/changwon.lee-e80b1cb266cbeb7ccfc10a3da52621cd.jpeg";